import React, { ReactElement, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import withStyles from 'react-jss';
import { bindActionCreators } from 'redux';

import { ChargeListCardsStyles } from 'src/components/pages/DiscoverRate/ChargeListCards.styles';
import Navbar from 'src/components/navbar/Navbar';
import DiscoverRateSearchBar from 'src/components/pages/DiscoverRate/DiscoverRateSearchBar';
import { getCreateInquiryRoute } from 'src/routing/utils';
import { setSearchFilterValues } from 'src/actions/discoverRatesActions';
import { DiscoverRatesProps } from './DiscoverRates.interface';
import {
  getDiscoverContentMainDiv,
  getContentStyle,
  getDiscoverContentStyle,
} from './DiscoverRates.styles';
import ChargeListCards from 'src/components/pages/DiscoverRate/ChargeListCards';

const DiscoverRates = (props: DiscoverRatesProps): ReactElement => {
  const { data, containerList, cargoList, history, setSearchFilterValues } = props;
  const {
    containerType,
    containerSize,
    cargoType,
    productType,
    type: activeKey,
    pol,
    pod,
    ffOrganisation,
    totalLocalCharge: isLocalsPresent,
    containerCount,
  } = data || {};

  const ffListMap = { [ffOrganisation?.id ?? 'FF']: { ...ffOrganisation } };
  const containerObj = containerList.find(
    (item) => item?.key?.type === containerType && item?.key?.size === containerSize
  );
  const cargoObj = cargoList.find(
    (item) => item?.key?.cargo === cargoType && item?.key?.product === productType
  );

  useEffect(() => {
    /* 
      Added data to search filters to avoid extra checks
      in ChargeListCards as well as in Create Inquiry Component
    */
    setSearchFilterValues({
      cargo: JSON.stringify(cargoObj),
      container: JSON.stringify(containerObj),
      pol,
      pod,
      containerCount,
    });
  }, []);

  const handleNewInquiry = (disableFields) => {
    history.push(getCreateInquiryRoute(), { disableFields, from: 'discoverRates' });
  };

  return (
    <div style={getDiscoverContentMainDiv()}>
      <Navbar pageTitle="Discover Rates" shouldDisplayBack={false} />
      <div style={getDiscoverContentStyle()}>
        <DiscoverRateSearchBar isSharingModule />
      </div>
      <div style={getContentStyle()}>
        <ChargeListCards
          data={data}
          isItemPresent={{ isLocalsPresent, activeKey, ffListMap, history, handleNewInquiry }}
          isShareModule
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ masterData }, ownProps) => ({
  containerList: masterData.containerList,
  cargoList: masterData.cargoList,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ setSearchFilterValues }, dispatch);
const ChargeListCardsStyled = withStyles(ChargeListCardsStyles)(DiscoverRates);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ChargeListCardsStyled));
